import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props } from './componentEl-33ff2aeb.js';

/**
This is a simple Circular Loader
*/

function Loader(_ref) {
  let {
    componentEl: Component,
    margin,
    size,
    className
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "margin", "size", "className"]);

  let cssClasses = ['st_loader', "st_loader--" + size];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps));
}

Loader.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for component, if any */
  margin: marginProps,

  /** size of loader */
  size: PropTypes.oneOf(['md', 'lg', 'xl'])
};
Loader.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  size: 'xl'
};

export default Loader;
